import React from 'react';

import { Skeleton } from 'components/ui/skeleton';

export function Banner({ bannerUrl }: { bannerUrl: string }) {
  return (
    <div data-testid="banner" className="flex w-full justify-center bg-white">
      <img
        src={bannerUrl}
        alt=""
        className="max-h-[400px] w-full object-contain"
      />
    </div>
  );
}

Banner.Skeleton = function BannerSkeleton() {
  return <Skeleton className="max-h-[400px] min-h-[100px] w-full" />;
};
